/**
 * 系统管理模块翻译 - 中文
 * 包含：用户管理、角色管理、菜单管理、部门管理、组织管理、权限分配、操作日志、业态类型
 */
export default {
  systemMgmt: {
    // ======== 用户管理 user ========
    user: {
      title: '用户管理',
      subtitle: '管理系统用户账户信息',
      allUsers: '全部',
      staffUsers: '商管员工',
      merchantUsers: '商户账号',
      userType: '账号类型',
      staffLabel: '商管',
      merchantLabel: '商户',
      addUser: '新增用户',
      editUser: '编辑用户',
      userList: '用户列表',
      username: '用户名',
      userCode: '用户编码',
      realname: '姓名',
      password: '密码',
      confirmPassword: '确认密码',
      newPassword: '新密码',
      gender: '性别',
      male: '男',
      female: '女',
      dept: '部门',
      deptName: '部门',
      role: '角色',
      roleAssign: '角色',
      assignRole: '分配角色',
      selectRole: '选择角色',
      org: '所属组织',
      headquarters: '总部',
      store: '门店',
      notSet: '未设置',
      unassignedOrg: '未分配组织',
      batchExport: '批量导出',
      batchImport: '批量导入',
      resetPassword: '重置密码',
      wxAccount: '微信账号',
      wxBoundYes: '已绑定',
      wxBoundNo: '未绑定',
      unbindWx: '解绑微信',
      unbindWxConfirm: '确认解绑用户「{name}」的微信小程序？解绑后需重新绑定才能用微信登录。',
      unbindWxSuccess: '微信解绑成功',
      unbindWxFailed: '微信解绑失败',
      searchPlaceholder: '搜索用户名、姓名或邮箱',
      usernamePlaceholder: '用户名',
      realnamePlaceholder: '姓名',
      passwordPlaceholder: '请输入密码',
      confirmPasswordPlaceholder: '请再次输入密码',
      newPasswordPlaceholder: '请输入新密码',
      emailPlaceholder: '请输入邮箱',
      phonePlaceholder: '请输入手机号',
      remarkPlaceholder: '备注信息',
      orgPlaceholder: '请选择所属组织',
      deptPlaceholder: '请选择部门',
      realnamePlaceholderInput: '请输入真实姓名',
      usernamePlaceholderInput: '请输入用户名',
      orgFilterTip: '请先选择所属组织，部门将自动过滤',
      deptFilterTip: '选择组织后，仅显示该组织下的部门',
      // 验证
      usernameRequired: '请输入用户名',
      usernameLength: '用户名长度在3-20个字符',
      usernamePattern: '用户名只能包含字母、数字和下划线',
      passwordRequired: '请输入密码',
      passwordLength: '密码长度在8-32个字符',
      confirmPasswordRequired: '请再次输入密码',
      passwordMismatch: '两次输入的密码不一致',
      realnameRequired: '请输入真实姓名',
      realnameLength: '姓名长度在2-10个字符',
      orgRequired: '请选择所属组织',
      deptRequired: '请选择部门',
      roleRequired: '请至少选择一个角色',
      statusRequired: '请选择状态',
      newPasswordRequired: '请输入新密码',
      // 消息
      fetchFailed: '获取用户列表失败',
      editSuccess: '编辑成功',
      addSuccess: '新增成功',
      deleteConfirm: '确定要删除用户 "{name}" 吗？',
      deleteConfirmIrreversible: '确定要删除用户 "{name}" 吗？此操作不可恢复！',
      batchDeleteConfirm: '确定要删除选中的 {count} 个用户吗？',
      batchDeleteConfirmIrreversible: '确定要删除选中的 {count} 个用户吗？此操作不可恢复！',
      batchDeleteTitle: '批量删除确认',
      batchDeleteSuccess: '批量删除成功',
      batchDeleteFailed: '批量删除失败',
      toggleStatusConfirm: '确定要{action}用户 "{name}" 吗？',
      toggleStatusTitle: '{action}确认',
      resetPasswordConfirm: '确定要重置用户 "{name}" 的密码吗？新密码将被设置为系统默认密码。',
      resetPasswordTitle: '重置密码确认',
      resetPasswordSuccess: '密码重置成功',
      resetPasswordFailed: '重置密码失败',
      resetPasswordSuccessWithPwd: '密码重置成功，新密码为: {pwd}',
      userInvalid: '用户信息无效',
      roleAssignSuccess: '角色分配成功',
      roleAssignFailed: '角色分配失败',
      fetchRolesFailed: '获取角色列表失败',
      exportLoading: '正在导出用户数据...',
      exportSuccess: '导出成功',
      exportFailed: '导出失败',
      orgLoadFailed: '组织列表加载失败',
      orgLoadError: '加载组织列表失败，请刷新页面重试',
      // 导入
      importTitle: '批量导入用户',
      importDesc: '导入说明',
      importFileTip: '仅支持.xlsx/.xls格式',
      importSizeTip: '文件大小不超过10MB',
      downloadTemplate: '下载导入模板',
      dataPreview: '数据预览',
      importResult: '导入结果',
      totalCount: '总数量',
      successCount: '成功',
      failCount: '失败',
      startImport: '开始导入',
      // 导出
      exportTitle: '批量导出用户',
      exportDesc: '导出说明',
      exportOptions: '导出选项',
      exportRange: '导出范围',
      currentQueryResult: '当前查询结果',
      allUserData: '全部用户数据',
      exportFields: '导出字段',
      selectAll: '全选',
      clearAll: '清空',
      defaultFields: '默认字段',
      fileName: '文件名',
      includePassword: '包含密码',
      include: '包含',
      exclude: '不包含',
      securityWarning: '导出密码存在安全风险，请谨慎操作',
      exportProgress: '导出进度',
      downloadFile: '下载文件',
      fieldUsername: '用户名',
      fieldRealname: '姓名',
      fieldEmail: '邮箱',
      fieldPhone: '手机号',
      fieldDept: '部门',
      fieldRole: '角色',
      fieldStatus: '状态',
      fieldCreateTime: '创建时间',
      fieldLastLogin: '最后登录',
      fieldRemark: '备注',
    },

    // ======== 角色管理 role ========
    role: {
      title: '角色管理',
      subtitle: '管理系统角色和权限配置',
      addRole: '新增角色',
      editRole: '编辑角色',
      roleList: '角色列表',
      roleName: '角色名称',
      roleKey: '角色标识',
      roleKeyAlt: '权限字符',
      roleSort: '排序',
      displayOrder: '显示顺序',
      roleDesc: '描述',
      permConfig: '权限配置',
      permAssign: '权限',
      dataScope: '数据权限',
      searchPlaceholder: '搜索角色名称或描述',
      roleNamePlaceholder: '请输入角色名称',
      roleKeyPlaceholder: '请输入角色标识',
      roleKeyInputPlaceholder: '请输入权限字符',
      statusPlaceholder: '请选择状态',
      remarkPlaceholder: '请输入角色备注',
      roleKeyTip: '权限字符将用于系统中标识该角色',
      // 验证
      roleNameRequired: '请输入角色名称',
      roleNameLength: '角色名称长度在 2 到 50 个字符',
      roleNameExists: '角色名称已存在',
      roleKeyRequired: '请输入权限字符',
      roleKeyLength: '权限字符长度在 2 到 100 个字符',
      roleKeyExists: '权限字符已存在',
      roleKeyPattern: '角色标识只能包含字母、数字和下划线',
      roleKeyCheckFailed: '验证角色标识失败',
      roleSortRequired: '请输入显示顺序',
      roleSortRange: '显示顺序必须在 0 到 999 之间',
      // 消息
      fetchFailed: '获取角色列表失败',
      roleUpdateSuccess: '角色更新成功',
      roleCreateSuccess: '角色创建成功',
      roleUpdateFailed: '角色更新失败',
      roleCreateFailed: '角色创建失败',
      saveFailed: '保存失败',
      deleteConfirm: '确定要删除角色 "{name}" 吗？',
      deleteConfirmIrreversible: '确定要删除角色 "{name}" 吗？此操作不可恢复！',
      batchDeleteConfirm: '确定要删除选中的 {count} 个角色吗？此操作不可恢复！',
      batchDeleteTitle: '批量删除确认',
      batchDeleteSuccess: '批量删除成功',
      batchDeleteFailed: '批量删除失败',
      toggleStatusConfirm: '确定要{action}角色 "{name}" 吗？',
      toggleStatusTitle: '{action}确认',
      fetchInfoFailed: '获取角色信息失败',
      exportLoading: '正在导出角色数据...',
      // 权限配置
      menuAndPermission: '菜单与功能权限',
      menuAndPermissionDesc: '配置角色可以访问的菜单、页面和功能操作权限',
      permissionConfig: '权限配置',
      expandAll: '展开全部',
      collapseAll: '收起全部',
      checkAll: '全选',
      uncheckAll: '取消全选',
      selectedPermissions: '已选权限',
      noPermissionSelected: '暂未选择任何权限',
      savePermConfig: '保存权限配置',
      roleInvalid: '角色信息无效',
      notSelected: '未选择角色',
      permSaveSuccess: '权限配置保存成功（共执行{count}项操作）',
      permSavePartial: '部分权限保存成功（{success}项），失败（{failed}项）：{errors}',
      permSaveFailed: '权限保存失败：{errors}',
      openPermFailed: '打开权限配置失败',
      fetchPermTreeFailed: '获取权限树失败',
      // 数据权限
      dataPermission: '数据权限',
      dataAccessScope: '数据访问范围',
      dataAccessScopeDesc: '配置角色可以访问的数据范围',
      dataScopeRange: '数据权限范围',
      allDataScope: '全部数据权限',
      allDataScopeDesc: '可以查看所有数据',
      customDataScope: '自定义数据权限',
      customDataScopeDesc: '可以查看指定部门的数据',
      deptDataScope: '本部门数据权限',
      deptDataScopeDesc: '只能查看本部门的数据',
      deptAndChildDataScope: '本部门及以下数据权限',
      deptAndChildDataScopeDesc: '可以查看本部门及子部门的数据',
      selfDataScope: '仅本人数据权限',
      selfDataScopeDesc: '只能查看和操作自己的数据',
      customDeptPerm: '自定义部门权限',
      customDeptRequired: '自定义数据权限必须选择部门',
      dataScopeSaveSuccess: '数据权限配置保存成功',
      dataScopeSaveFailed: '数据权限配置保存失败',
      fetchDeptTreeFailed: '获取部门树失败',
      fetchDataScopeFailed: '获取角色数据权限失败',
      selectDeptTip: '选择角色可以访问的部门：',
      selectDeptPlaceholder: '请选择部门',
      deptTip: '选择的部门将决定角色能访问的数据范围',
      saveConfig: '保存配置',
      // 菜单类型
      menuTypeDir: '目录',
      menuTypeMenu: '菜单',
      menuTypeBtn: '功能',
    },

    // ======== 菜单管理 menu ========
    menu: {
      title: '菜单管理',
      subtitle: '管理系统菜单结构和权限配置',
      addMenu: '新增菜单',
      editMenu: '编辑菜单',
      menuList: '菜单列表',
      menuName: '菜单名称',
      menuType: '菜单类型',
      menuIcon: '菜单图标',
      orderNum: '排序',
      displayOrder: '显示排序',
      routePath: '路由地址',
      component: '组件路径',
      perms: '权限标识',
      visibleStatus: '显示状态',
      menuStatus: '菜单状态',
      parentMenu: '上级菜单',
      addChildMenu: '新增子菜单',
      mainDir: '主目录',
      typeDir: '目录',
      typeMenu: '菜单',
      typeBtn: '按钮',
      show: '显示',
      hide: '隐藏',
      collapseAll: '收起全部',
      expandAll: '展开全部',
      searchPlaceholder: '搜索菜单名称',
      menuNamePlaceholder: '请输入菜单名称',
      parentMenuPlaceholder: '选择上级菜单',
      routePathPlaceholder: '请输入路由地址',
      componentPlaceholder: '请输入组件路径',
      iconPlaceholder: '请输入图标名称',
      permsPlaceholder: '请输入权限标识，如：system:user:list',
      remarkPlaceholder: '请输入备注信息',
      // 验证
      menuNameRequired: '请输入菜单名称',
      menuNameLength: '长度在 2 到 50 个字符',
      menuTypeRequired: '请选择菜单类型',
      orderNumRequired: '请输入显示排序',
      routePathRequired: '请输入路由地址',
      // 消息
      fetchFailed: '获取菜单列表失败',
      fetchInfoFailed: '获取菜单信息失败',
      deleteConfirm: '确定要删除菜单"{name}"吗？删除后不可恢复！',
      deleteWarning: '警告',
      deleteFailed: '删除菜单失败',
      statusUpdateSuccess: '状态更新成功',
      statusUpdateFailed: '更新状态失败',
      createSuccess: '创建成功',
      updateSuccess: '更新成功',
    },

    // ======== 部门管理 dept ========
    dept: {
      title: '部门管理',
      subtitle: '管理系统组织架构和部门层级关系',
      addDept: '新增部门',
      editDept: '编辑部门',
      deptList: '部门列表',
      deptName: '部门名称',
      deptCode: '部门编码',
      parentDept: '上级部门',
      belongOrg: '所属组织',
      leader: '负责人',
      leaderPhone: '联系电话',
      sortOrder: '显示排序',
      deptUsers: '部门用户',
      assignLeader: '指定负责人',
      orgFilter: '按组织筛选',
      filterByOrg: '按组织筛选',
      expandAll: '展开全部',
      collapseAll: '收起全部',
      root: '根',
      notBound: '未绑定',
      notSet: '未设置',
      headquarters: '总部',
      store: '门店',
      searchPlaceholder: '部门名称、编码或负责人',
      deptNamePlaceholder: '请输入部门名称',
      deptCodePlaceholder: '请输入部门编码',
      parentDeptPlaceholder: '选择上级部门（不选则为根部门）',
      orgPlaceholder: '请选择所属组织',
      orgFilterPlaceholder: '请选择组织',
      leaderPlaceholder: '请输入负责人姓名',
      phonePlaceholder: '请输入联系电话',
      emailPlaceholder: '请输入邮箱地址',
      sortPlaceholder: '排序号',
      remarkPlaceholder: '请输入部门备注信息',
      orgTip: '每个部门必须归属一个组织（总部或门店）',
      codeTip: '部门编码用于系统内部标识',
      activeText: '启',
      inactiveText: '停',
      // 部门类型
      deptCategory: '部门类型',
      deptCategoryPlaceholder: '请选择部门类型',
      categoryHeadquarters: '总部',
      categoryProject: '项目',
      categoryStore: '项目/门店',
      categoryNormal: '普通部门',
      categorySales: '销售部门',
      categoryPurchase: '采购部门',
      categoryWarehouse: '仓储部门',
      categoryFinance: '财务部门',
      categoryOperation: '运营部门',
      categoryInvestment: '招商部门',
      isLeaf: '末级部门',
      isLeafTip: '标记为末级后，该部门下不允许再创建子部门',
      segmentPlaceholder: '第{level}级编码({length}位数字)',
      codeNumeric: '编码段只能输入数字',
      // 验证
      orgRequired: '请选择所属组织',
      parentDeptRequired: '请选择上级部门',
      deptCodeRequired: '请输入部门编码',
      deptNameRequired: '请输入部门名称',
      deptNameLength: '部门名称长度在 2 到 50 个字符',
      sortOrderRequired: '请输入显示排序',
      sortOrderRange: '排序必须在 0 到 999 之间',
      phonePattern: '请输入正确的手机号码',
      emailPattern: '请输入正确的邮箱地址',
      statusRequired: '请选择状态',
      // 消息
      fetchFailed: '获取部门列表失败',
      deleteConfirm: '确定要删除部门 "{name}" 吗？此操作不可恢复！',
      createSuccess: '新增成功',
      updateSuccess: '更新成功',
      orgLoadFailed: '组织列表加载失败',
      orgLoadError: '加载组织列表失败，请刷新页面重试',
      // 部门用户
      deptUsersTitle: '部门用户 - {name}',
      searchUserPlaceholder: '搜索用户名、姓名或手机号',
      joinTime: '入职时间',
      userDetail: '用户详情',
      lastLogin: '最后登录',
      neverLogin: '从未登录',
      fetchUsersFailed: '获取部门用户失败',
      // 负责人分配
      assignLeaderTitle: '分配部门负责人',
      selectUser: '选择用户',
      selectLeaderPlaceholder: '请选择负责人',
      notAssigned: '未分配部门',
      leaderPermTip: '负责人将拥有该部门的管理权限',
      positionDesc: '职位说明',
      positionPlaceholder: '请输入负责人职位',
      effectiveTime: '生效时间',
      effectiveTimePlaceholder: '选择生效时间',
      effectiveTimeTip: '不填写则立即生效',
      leaderHistory: '历史负责人记录',
      noLeaderHistory: '暂无负责人记录',
      confirmAssign: '确定分配',
      assignSuccess: '负责人分配成功',
      assignFailed: '负责人分配失败',
      selectNodeTip: '请从左侧选择一个部门查看详情',
      childDeptList: '子部门列表',
    },

    // ======== 组织管理 org ========
    org: {
      title: '组织管理',
      subtitle: '管理系统组织架构（总部、门店/项目）',
      addOrg: '新增组织',
      editOrg: '编辑组织',
      orgList: '组织列表',
      orgName: '组织名称',
      orgCode: '组织编码',
      orgLevel: '组织层级',
      parentOrg: '上级组织',
      leader: '负责人',
      leaderPhone: '负责人电话',
      contactPhone: '联系电话',
      address: '地址',
      sortOrder: '排序',
      displayOrder: '显示排序',
      businessScope: '业务范围',
      totalArea: '总建筑面积',
      rentableArea: '可租赁面积',
      headquarters: '总部',
      storeProject: '门店/项目',
      deptLevel: '部门',
      teamLevel: '团队',
      searchPlaceholder: '组织名称或编码',
      orgNamePlaceholder: '请输入组织名称',
      orgCodePlaceholder: '请输入组织编码',
      parentOrgPlaceholder: '选择上级组织（不选则为根组织）',
      orgLevelPlaceholder: '选择组织层级',
      leaderPlaceholder: '请输入负责人姓名',
      leaderPhonePlaceholder: '请输入负责人电话',
      contactPhonePlaceholder: '请输入联系电话',
      addressPlaceholder: '请输入地址',
      totalAreaPlaceholder: '请输入总建筑面积',
      rentableAreaPlaceholder: '请输入可租赁面积',
      businessScopePlaceholder: '请输入业务范围',
      remarkPlaceholder: '请输入备注信息',
      sortPlaceholder: '排序号',
      codeTip: '组织编码用于系统内部标识',
      levelTip: '仅支持总部和门店/项目两个层级',
      areaTip: '单位：m²',
      rentableAreaTip: '单位：m²，业态规划基准面积',
      // 验证
      orgNameRequired: '请输入组织名称',
      orgNameLength: '组织名称长度在 2 到 100 个字符',
      orgCodeRequired: '请输入组织编码',
      orgCodeLength: '组织编码长度在 2 到 50 个字符',
      orgCodePattern: '组织编码只能包含字母、数字、下划线和横线',
      orgLevelRequired: '请选择组织层级',
      sortOrderRange: '排序必须在 0 到 999 之间',
      leaderPhonePattern: '请输入正确的手机号码',
      contactPhonePattern: '联系电话格式不正确',
      statusRequired: '请选择状态',
      // 消息
      fetchFailed: '获取组织列表失败',
      deleteConfirm: '确定要删除组织 "{name}" 吗？此操作不可恢复！',
      createSuccess: '新增成功',
      updateSuccess: '更新成功',
    },

    // ======== 权限分配 permAssign ========
    permAssign: {
      title: '权限分配',
      subtitle: '管理部门资源管辖权限和用户资源权限',
      deptResource: '部门资源管辖',
      userResource: '用户资源权限',
      assignDeptPerm: '分配管辖权限',
      assignUserPerm: '分配用户权限',
      resourceType: '资源类型',
      resourceId: '资源ID',
      manageDept: '管辖部门',
      manageType: '管理类型',
      permissionScope: '权限范围',
      permissionType: '权限类型',
      effectiveTime: '生效时间',
      expireTime: '失效时间',
      startTimePlaceholder: '开始时间',
      endTimePlaceholder: '结束时间',
      selectDeptPlaceholder: '选择部门',
      selectUserPlaceholder: '选择用户',
      selectResourceType: '请选择资源类型',
      selectManageType: '请选择管理类型',
      selectPermType: '请选择权限类型',
      inputResourceId: '请输入资源ID',
      scopeDescPlaceholder: '请描述权限范围',
      remarkPlaceholder: '备注信息',
      assignDeptTitle: '分配部门管辖权限',
      assignUserTitle: '分配用户资源权限',
      query: '查询',
      // 验证
      resourceTypeRequired: '请选择资源类型',
      resourceIdRequired: '请输入资源ID',
      deptRequired: '请选择部门',
      manageTypeRequired: '请选择管理类型',
      userRequired: '请选择用户',
      permTypeRequired: '请选择权限类型',
      // 消息
      fetchResourceTypesFailed: '加载资源类型失败',
      fetchManageTypesFailed: '加载管理类型失败',
      fetchPermTypesFailed: '加载权限类型失败',
      fetchDeptsFailed: '加载部门列表失败',
      fetchUsersFailed: '加载用户列表失败',
      fetchDeptPermFailed: '加载部门管辖权限失败',
      fetchUserPermFailed: '加载用户权限失败',
      statusUpdateSuccess: '状态更新成功',
      statusUpdateFailed: '状态更新失败',
      deleteConfirm: '确定要删除这条管辖权限记录吗？',
      userPermToggleTodo: '用户权限状态切换功能待实现',
      userPermDeleteTodo: '用户权限删除功能待实现',
      deptPrefix: '部门',
      userPrefix: '用户',
    },

    // ======== 权限矩阵 permMatrix ========
    permMatrix: {
      title: '权限矩阵配置',
      subtitle: '配置用户或角色的数据访问权限矩阵',
      resourceType: '资源类型',
      resourceTypePlaceholder: '请选择资源类型',
      permSubject: '权限主体',
      permSubjectPlaceholder: '请选择权限主体',
      userPerm: '用户权限',
      rolePerm: '角色权限',
      selectUserRole: '选择用户/角色',
      loadMatrix: '加载权限矩阵',
      resetPerm: '重置权限',
      savePermConfig: '保存权限配置',
      permPreview: '权限预览',
      currentConfig: '当前配置',
      permRange: '权限范围',
      lastUpdate: '最后更新',
      customPermConfig: '自定义权限配置',
      operationType: '操作类型',
      permExpression: '权限表达式',
      configDesc: '配置说明',
      sqlPlaceholder: 'SQL 过滤条件',
      configHelp: '权限表达式用于数据过滤，留空表示使用默认策略',
      scopeAll: '全部数据',
      scopeAllDesc: '可访问所有数据',
      scopeCustom: '自定义数据',
      scopeCustomDesc: '按指定条件过滤',
      scopeDept: '本部门数据',
      scopeDeptDesc: '仅限本部门数据',
      scopeDeptAndChild: '本部门及以下',
      scopeDeptAndChildDesc: '本部门和子部门数据',
      scopeSelf: '个人数据',
      scopeSelfDesc: '仅限本人创建的数据',
      authorized: '已授权',
      unauthorized: '未授权',
      deptData: '部门数据',
      assetData: '资产数据',
      merchantData: '商户数据',
      opView: '查看',
      opAdd: '新增',
      opEdit: '修改',
      opDelete: '删除',
      noData: '暂无',
      configItemsCount: '{configured} / {total} 项已配置',
      customConfigBtn: '自定义配置',
      configHelpTitle: '配置说明',
      configHelpLine1: '支持SQL条件表达式来定义权限范围',
      configHelpLine2: '可以使用字段名、比较运算符、IN、LIKE等',
      configHelpLine3: '示例：dept_id IN (1,2,3) 或 create_time >= \'2024-01-01\'',
      sqlExpressionRequired: '请输入权限表达式',
      customConfigSaved: '自定义配置保存成功',
      permResetSuccess: '权限配置已重置',
      permSaveSuccess: '权限配置保存成功',
      permLoadSuccess: '权限矩阵加载成功',
      resourceTypeEmpty: '资源类型数据为空',
      matrixTitle: '{resourceType} - {subjectType}权限矩阵',
      userLabel: '用户',
      roleLabel: '角色',
      selectUserRolePlaceholder: '请选择用户或角色',
      // 消息
      resetConfirm: '确定要重置当前权限配置吗？此操作不可恢复。',
      resetTitle: '重置权限',
      saveConfirm: '确定要保存当前权限矩阵配置吗？',
      loadFailed: '加载权限矩阵失败',
      saveFailed: '保存失败',
      loadResourceTypesFailed: '加载资源类型失败',
      loadSubjectOptionsFailed: '加载用户/角色列表失败',
    },

    // ======== 操作日志 logs ========
    logs: {
      title: '操作日志',
      subtitle: '查看系统操作记录和审计日志',
      logList: '日志列表',
      logDetail: '日志详情',
      operStatus: '操作状态',
      operType: '操作类型',
      operationType: '操作类型',
      dateRange: '日期范围',
      to: '至',
      searchPlaceholder: '操作人、IP或描述',
      id: 'ID',
      operator: '操作人',
      operDesc: '操作描述',
      description: '描述',
      ipAddress: 'IP地址',
      ip: 'IP地址',
      responseTime: '耗时(ms)',
      operTime: '操作时间',
      operationTime: '操作时间',
      module: '模块',
      moduleName: '模块名称',
      function: '功能',
      functionName: '功能名称',
      requestMethod: '请求方法',
      requestParams: '请求参数',
      requestData: '请求数据',
      responseData: '响应数据',
      responseResult: '响应结果',
      errorMsg: '错误信息',
      success: '成功',
      fail: '失败',
      username: '用户名',
      cleanLogs: '清空日志',
      cleanConfirm: '确定要清空所有操作日志吗？此操作不可恢复。',
      cleanSuccess: '清空成功',
      cleanFailed: '清空失败',
      exportLogs: '导出日志',
      exportSuccess: '导出成功',
      exportFailed: '导出失败',
      // 操作类型
      typeLogin: '登录',
      typeLogout: '登出',
      typeAdd: '新增',
      typeUpdate: '修改',
      typeDelete: '删除',
      typeQuery: '查询',
      typeExport: '导出',
      typeImport: '导入',
      typeGrant: '授权',
      typeTest: '测试',
      // 消息
      fetchFailed: '获取日志列表失败',
    },

    // ======== 业态类型 businessType ========
    businessType: {
      title: '业态分类',
      subtitle: '管理购物中心业态分类体系，支持多级分类配置',
      addType: '新增分类',
      addTopLevel: '新增一级分类',
      addChild: '新增子分类',
      addChildBtn: '添加子级',
      editType: '编辑分类',
      typeList: '业态分类列表',
      typeName: '业态名称',
      typeCode: '编码',
      level: '层级',
      color: '颜色',
      sortOrder: '排序',
      icon: '图标',
      description: '描述',
      topLevel: '一级',
      childItems: '{count}子项',
      topCategory: '顶级分类',
      statusPlaceholder: '全部',
      searchPlaceholder: '业态名称或编码',
      typeNamePlaceholder: '请输入业态分类名称',
      typeCodePlaceholder: '请输入业态分类编码（如 RETAIL）',
      parentPlaceholder: '选择上级分类（不选则为一级分类）',
      iconPlaceholder: 'Lucide 图标名称（如 ShoppingBag）',
      descPlaceholder: '业态分类描述（选填）',
      remarkPlaceholder: '备注信息（选填）',
      autoGenerate: '自动生成',
      activeText: '启',
      inactiveText: '停',
      // 验证
      typeNameRequired: '请输入业态分类名称',
      typeNameLength: '名称长度在 1 到 100 个字符',
      typeCodeRequired: '请输入业态分类编码',
      typeCodePattern: '编码必须以大写字母开头，只能包含大写字母、数字和下划线',
      typeCodeExists: '业态分类编码已存在，请更换',
      // 消息
      fetchFailed: '获取业态分类列表失败',
      deleteConfirm: '确定要删除业态分类 "{name}" 吗？如果存在子分类，将无法删除。',
      createSuccess: '创建成功',
      updateSuccess: '更新成功',
    },

    // ======== 费用项目 feeItem ========
    feeItem: {
      title: '费用项目管理',
      subtitle: '管理合同费用项目配置，支持多种计费方式',
      addItem: '新增费用项目',
      editItem: '编辑费用项目',
      itemList: '费用项目列表',
      itemCode: '费用编码',
      itemName: '费用名称',
      category: '费用类别',
      calcType: '计费方式',
      defaultValue: '默认值',
      unit: '单位',
      sortOrder: '排序',
      isSystem: '系统内置',
      isRequired: '是否必填',
      remark: '备注',
      // 开票设置
      invoiceSettings: '开票设置',
      invoiceGoodsName: '开票名目',
      taxClassifyCode: '税收编码',
      taxRate: '税率',
      invoiceNotSet: '未配置',
      // 类别
      categoryRent: '租金',
      categoryProperty: '物业费',
      categoryUtility: '水电费',
      categoryDeposit: '保证金',
      categoryMarketing: '推广费',
      categoryIntention: '意向金',
      categoryOther: '其他',
      // 计费方式
      calcTypeSqMonthly: '按面积/月',
      calcTypeFixedMonthly: '固定/月',
      calcTypeFixedOnce: '固定一次性',
      calcTypePercent: '按比例',
      // 费用属性
      feeAttribute: '费用属性',
      feeAttributeCost: '记成本',
      feeAttributeFee: '记费用',
      feeAttributePlaceholder: '请选择费用属性',
      // 收款方式
      collectionMethod: '收款方式',
      collectionMethodDeduct: '账扣',
      collectionMethodCash: '现金',
      collectionMethodPlaceholder: '请选择收款方式',
      // 标签
      systemBuilt: '系统',
      required: '必填',
      optional: '选填',
      // 占位符
      searchPlaceholder: '费用编码或名称',
      categoryPlaceholder: '全部类别',
      statusPlaceholder: '全部状态',
      itemCodePlaceholder: '请输入费用编码（如 RENT_BASE）',
      itemNamePlaceholder: '请输入费用名称',
      calcTypePlaceholder: '请选择计费方式',
      defaultValuePlaceholder: '请输入默认值',
      unitPlaceholder: '如：元、月',
      remarkPlaceholder: '备注信息（选填）',
      invoiceGoodsNamePlaceholder: '如：不动产租赁服务、物业管理服务',
      taxClassifyCodePlaceholder: '19位税收分类编码',
      selectTaxClassifyCode: '请选择末级税收分类编码',
      autoFromTaxCode: '由税收分类编码自动填充',
      // 提示
      hintSqMonthly: '元/㎡/月',
      hintFixedMonthly: '元/月',
      hintFixedOnce: '元',
      hintPercent: '%',
      taxRateHint: '例：0.09 表示 9%',
      activeText: '启',
      inactiveText: '停',
      // 验证
      itemCodeRequired: '请输入费用编码',
      itemCodePattern: '编码必须以大写字母开头，只能包含大写字母、数字和下划线',
      itemNameRequired: '请输入费用名称',
      itemNameLength: '名称长度不能超过100个字符',
      categoryRequired: '请选择费用类别',
      calcTypeRequired: '请选择计费方式',
      // 消息
      fetchFailed: '获取费用项目列表失败',
      deleteConfirm: '确定要删除费用项目 "{name}" 吗？',
    },

    // ======== 付款方式 paymentMethod ========
    paymentMethod: {
      title: '付款周期管理',
      subtitle: '管理合同付款周期配置，支持周期设置和滞纳金规则',
      addMethod: '新增付款周期',
      editMethod: '编辑付款周期',
      methodList: '付款周期列表',
      methodCode: '编码',
      methodName: '名称',
      cycleType: '周期类型',
      cycleDays: '周期',
      unitMonths: '月',
      unitDays: '天',
      unitDay: '日',
      defaultDueDays: '付款期限',
      defaultDueDaysHint: '出单后多少天内付款',
      cycleMonthsHint: '按月计算，自动适配大小月',
      cycleDaysHint: '按固定天数计算',
      billTiming: '出单时机',
      billDay: '出单日',
      endOfMonth: '月末',
      billDayHint: '选择"月末"时，系统自动取当月最后一天',
      selectBillDay: '请选择出单日',
      lateFee: '滞纳金',
      lateFeeEnabled: '启用滞纳金',
      lateFeeType: '滞纳金类型',
      lateFeeValue: '滞纳金值',
      lateFeeCap: '滞纳金上限',
      graceDays: '宽限期',
      isSystem: '系统内置',
      days: '天',
      yuan: '元',
      // 周期类型
      cycleMonth: '月付',
      cycleQuarter: '季付',
      cycleSemiAnnual: '半年付',
      cycleYear: '年付',
      cycleCustom: '自定义',
      // 出单时机
      billCurrent: '当月出单',
      billAdvance: '提前出单',
      billNext: '次月出单',
      // 滞纳金类型
      lateFeeFixed: '固定金额',
      lateFeePercentDaily: '按日百分比',
      lateFeePercentOnce: '一次性百分比',
      // 表单分区
      basicInfo: '基本信息',
      cycleSettings: '付款周期设置',
      dueDateSettings: '付款截止设置',
      billSettings: '出单设置',
      lateFeeSettings: '滞纳金设置',
      otherSettings: '其他设置',
      // 截止类型
      dueDateType: '截止日期类型',
      dueDateTypeDays: '指定天数',
      dueDateTypeSpecific: '指定日期',
      dueValue: '截止日期值',
      dueDaysHint: '出单后多少天内需完成付款',
      dueDateHint: '每月几号为付款截止日，支持跨月（如出单日25号，截止日10号）',
      // 占位符
      searchPlaceholder: '编码或名称',
      methodCodePlaceholder: '请输入付款方式编码（如 MONTHLY）',
      methodNamePlaceholder: '请输入付款方式名称',
      // 提示
      defaultDueDayHint: '每月的付款截止日期（1-28日）',
      lateFeeCapHint: '滞纳金最大金额，0表示无上限',
      graceDaysHint: '逾期后允许的宽限天数，宽限期内不计算滞纳金',
      // 验证
      methodCodeRequired: '请输入付款方式编码',
      methodCodePattern: '编码只能包含字母、数字和下划线',
      methodNameRequired: '请输入付款方式名称',
      cycleTypeRequired: '请选择周期类型',
      cycleDaysRequired: '请输入周期天数',
      billTimingRequired: '请选择出单时机',
      // 消息
      fetchFailed: '获取付款方式列表失败',
      deleteConfirm: '确定要删除付款方式 "{name}" 吗？',
      cannotDeleteSystem: '系统内置付款方式不可删除',
      cannotDisableSystem: '系统内置付款方式不可停用',
    },

    // ======== 收费主体 signCompany ========
    signCompany: {
      title: '收费主体管理',
      addCompany: '新增收费主体',
      editCompany: '编辑收费主体',
      companyName: '公司名称',
      companyCode: '统一社会信用代码',
      legalPerson: '法定代表人',
      bankName: '开户银行',
      bankAccount: '银行账号',
      businessScope: '经营范围',
      companyNamePh: '请输入公司名称',
      companyCodePh: '请输入统一社会信用代码',
      businessScopePh: '如：租金、物业费、水电费等',
      // 验证
      companyNameRequired: '请输入公司名称',
      companyNameLength: '公司名称长度在 2 到 200 个字符',
      // 消息
      fetchFailed: '获取收费主体列表失败',
      createSuccess: '收费主体创建成功',
      updateSuccess: '收费主体更新成功',
      deleteConfirm: '确定要删除收费主体 "{name}" 吗？',
    },

    // ======== 打印模板 printTemplate ========
    printTemplate: {
      title: '打印模板管理',
      subtitle: '管理可视化打印模板，支持拖拽设计和自定义布局',
      addTemplate: '新增模板',
      editTemplate: '编辑模板',
      designTemplate: '设计模板',
      templateList: '模板列表',
      templateName: '模板名称',
      templateKey: '业务类型',
      paperType: '纸张规格',
      orientation: '打印方向',
      isDefault: '默认模板',
      version: '版本',
      // 业务类型选项
      keyContract: '招商合同',
      keyBill: '缴费账单',
      keyMonthlyFee: '月度费用',
      keyRenovation: '装修通知',
      keyCollection: '催缴通知',
      // 纸张选项
      paperA4: 'A4',
      paperA5: 'A5',
      paperCustom: '自定义',
      // 方向选项
      portrait: '纵向',
      landscape: '横向',
      // 占位符
      searchPlaceholder: '模板名称',
      templateKeyPlaceholder: '全部类型',
      statusPlaceholder: '全部状态',
      templateNamePlaceholder: '请输入模板名称',
      remarkPlaceholder: '备注信息（选填）',
      // 操作
      setDefault: '设为默认',
      cloneTemplate: '克隆',
      design: '设计',
      preview: '预览',
      // 设计器
      designerTitle: '模板设计器',
      dragHint: '拖拽左侧元素到画布',
      basicElements: '基础元素',
      fieldPanel: '业务字段',
      propertyPanel: '属性设置',
      saveDesign: '保存设计',
      clearCanvas: '清空画布',
      // 验证
      templateNameRequired: '请输入模板名称',
      templateKeyRequired: '请选择业务类型',
      // 消息
      fetchFailed: '获取模板列表失败',
      createSuccess: '模板创建成功',
      updateSuccess: '模板更新成功',
      deleteConfirm: '确定要删除模板 "{name}" 吗？',
      setDefaultSuccess: '已设为默认模板',
      cloneSuccess: '模板克隆成功',
      saveDesignSuccess: '模板设计保存成功',
      clearConfirm: '确定要清空画布吗？此操作不可恢复。',
      noTemplate: '暂无自定义模板，使用默认打印样式',
    },

    // ======== 通知模板 notificationTemplate ========
    notificationTemplate: {
      title: '通知模板管理',
      subtitle: '管理系统通知模板，支持动态配置和实时生效',
      addTemplate: '新增模板',
      editTemplate: '编辑模板',
      templateList: '模板列表',
      templateKey: '模板标识',
      templateName: '模板名称',
      type: '通知类型',
      titlePattern: '标题模板',
      contentPattern: '内容模板',
      linkPattern: '链接模板',
      recipientRoles: '收件角色',
      notifyCreator: '通知创建人',
      priority: '优先级',
      bizType: '业务类型',
      channels: '通知渠道',
      description: '描述',
      sortOrder: '排序',
      isSystem: '系统内置',
      // 业务类型
      bizTypeContract: '合同',
      bizTypeBilling: '账单',
      bizTypeRenovation: '装修',
      bizTypeIntention: '意向',
      bizTypeWorkOrder: '工单',
      bizTypeTask: '任务',
      // 占位符
      templateKeyPlaceholder: '请输入模板标识（如 CONTRACT_SUBMITTED）',
      templateNamePlaceholder: '请输入模板名称',
      templateKeyRequired: '请输入模板标识',
      templateKeyMaxLength: '模板标识长度不能超过100个字符',
      templateNameRequired: '请输入模板名称',
      templateNameMaxLength: '模板名称长度不能超过100个字符',
      typeRequired: '请选择通知类型',
      titlePatternPlaceholder: '如：合同待审批 - {bizNo}',
      titlePatternRequired: '请输入标题模板',
      titlePatternMaxLength: '标题模板长度不能超过200个字符',
      contentPatternPlaceholder: '如：合同 {bizNo} 已提交审批，请及时处理。支持 {bizId} 和 {bizNo} 占位符',
      contentPatternRequired: '请输入内容模板',
      contentPatternMaxLength: '内容模板长度不能超过500个字符',
      linkPatternPlaceholder: '如：/contract/rent?id={bizId}',
      recipientRolesPlaceholder: '角色key，多个用逗号分隔，如：admin,finance_manager',
      descriptionPlaceholder: '模板描述信息',
      priorityRequired: '请选择优先级',
      bizTypeRequired: '请选择业务类型',
      // 通知类型
      typeBusiness: '业务通知',
      typeApproval: '审批通知',
      typeSystem: '系统通知',
      // 优先级
      priorityHigh: '高',
      priorityNormal: '普通',
      priorityLow: '低',
      // 渠道
      channelInApp: '站内通知',
      channelInAppMini: '站内+小程序',
      channelMiniApp: '小程序',
      // 消息
      fetchFailed: '获取通知模板列表失败',
      cannotDeleteSystem: '系统内置模板不可删除',
      deleteConfirm: '确定要删除通知模板 "{name}" 吗？',
    },

    // ======== 支付工具 payInstrument ========
    payInstrument: {
      title: '支付工具管理',
      subtitle: '管理支付工具定义（现金/微信/支付宝/银行卡等）',
      addItem: '新增支付工具',
      editItem: '编辑支付工具',
      instrumentCode: '支付编码',
      instrumentName: '支付名称',
      instrumentType: '支付类型',
      processMode: '处理模式',
      isSales: '计入销售',
      isInvoice: '可开票',
      sortOrder: '排序',
      statusText: '状态',
      remark: '备注',
      // 类型
      typeCash: '现金',
      typeWechat: '微信',
      typeAlipay: '支付宝',
      typeCoupon: '优惠券',
      typeBankCard: '银行卡',
      typeCheck: '支票',
      typeGiftCard: '礼品卡',
      // 处理模式
      modeNoLimit: '无限制',
      modeNoChange: '余额不找零',
      modeNoOverpay: '不可超额',
      // 占位符
      searchPlaceholder: '编码或名称',
      instrumentCodePlaceholder: '请输入支付编码（如 CASH）',
      instrumentNamePlaceholder: '请输入支付名称',
      // 验证
      instrumentCodeRequired: '请输入支付编码',
      instrumentNameRequired: '请输入支付名称',
      // 消息
      fetchFailed: '获取支付工具列表失败',
      deleteConfirm: '确定要删除支付工具 "{name}" 吗？',
    },

    // ======== 编码规则 codeRule ========
    codeRule: {
      title: '编码规则',
      subtitle: '管理系统编码生成规则配置',
      ruleList: '规则列表',
      editRule: '编辑编码规则',
      ruleName: '规则名称',
      codePattern: '编码模式',
      patternHierarchical: '层级编码',
      patternPureSeq: '纯序列',
      patternDateSeq: '日期序列',
      prefix: '前缀',
      prefixPlaceholder: '如 PRD、USR',
      separator: '分隔符',
      separatorPlaceholder: '如 -',
      seqLength: '序列位数',
      digits: '位',
      example: '编码示例',
      genMode: '生成模式',
      autoGen: '自动生成',
      manualGen: '手动输入',
      basicInfo: '基本信息',
      codeConfig: '编码配置',
      otherSettings: '其他设置',
      dateFormat: '日期格式',
      resetCycle: '重置周期',
      resetDaily: '每日重置',
      resetYearly: '每年重置',
      resetNever: '永不重置',
      maxLevel: '最大层级',
      levelLengths: '各级位数',
      levelLabel: '第{n}级',
      preview: '编码预览',
      ruleNameRequired: '请输入规则名称',
      seqLengthRequired: '请输入序列位数',
      fetchFailed: '获取编码规则列表失败',
    },

    // ======== 通用 (系统管理范围内) ========
    common: {
      keyword: '关键词',
      statusNormal: '正常',
      statusDisabled: '禁用',
      statusStopped: '停用',
      enable: '启用',
      disable: '禁用',
      stop: '停用',
      enableShort: '启',
      stopShort: '停',
      create: '创建',
      update: '更新',
      user: '用户',
    },

    // ======== 定时任务日志 jobLog ========
    jobLog: {
      title: '定时任务日志',
      subtitle: '查看系统定时任务执行记录',
      taskName: '任务名称',
      taskGroup: '任务分组',
      cronExpr: 'Cron表达式',
      status: '执行状态',
      success: '成功',
      fail: '失败',
      startTime: '开始时间',
      endTime: '结束时间',
      duration: '耗时(ms)',
      resultMsg: '结果摘要',
      errorMsg: '错误信息',
      allTasks: '全部任务',
      searchPlaceholder: '搜索任务名称',
      cleanLogs: '清理日志',
      cleanConfirm: '确定要清理30天前的任务日志吗？此操作不可恢复。',
      cleanSuccess: '清理成功',
      cleanFailed: '清理失败',
      trigger: '手动触发',
      triggerConfirm: '确定要手动触发任务 "{name}" 吗？',
      triggerSuccess: '任务已触发',
      triggerFailed: '触发失败',
      fetchFailed: '获取任务日志失败',
      logDetail: '日志详情',
      noData: '暂无数据',
    },

    // ======== 系统配置 sysConfig ========
    sysConfig: {
      title: '系统配置',
      subtitle: '管理系统参数配置',
      noData: '暂无配置项',
      groupWatermark: '水印设置',
      groupSecurity: '安全策略',
      groupNotification: '通知设置',
    },
  },
}
